import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'
import TableComponent from '../../../components/Common/TableComponent'
import { Empty, Pagination, Spin } from 'antd'
import { TableBottomPaginationBlock } from '../../../components/Common/Table'
import moment from 'moment'

const AssetStatisticsTable = props => {
  const { managementAssetWarehouseStore, isLoading, currentDate } = props

  const {
    assetStatisticList,
    pageIndex,
    sizeIndex,
    totalCount,
  } = managementAssetWarehouseStore

  useEffect(() => {
    ;(async () => {
      await managementAssetWarehouseStore.clearFilter()
    })()
  }, [])

  const handleChangePage = useCallback(
    p => {
      const pageIndex = p - 1
      managementAssetWarehouseStore.setFilter('pageIndex', pageIndex)
    },
    [managementAssetWarehouseStore]
  )

  const calculateAssetStatistics = record => {
    const itemLastMonth = record?.assetHistories?.filter(item => {
      const itemDate = new Date(item?.createAt)
      const [compareMonth, compareYear] = currentDate.split('-')
      const currentDateObject = new Date(compareYear, compareMonth - 1)
      return (
        item?.type === 'LASTMONTH' &&
        (itemDate.getFullYear() < currentDateObject.getFullYear() ||
          (itemDate.getFullYear() === currentDateObject.getFullYear() &&
            itemDate.getMonth() < currentDateObject.getMonth()))
      )
    })

    const itemCreate = record?.assetHistories?.filter(
      item => item?.type === 'CREATE'
    )
    const itemUpdate = record?.assetHistories?.filter(
      item => item?.type === 'UPDATE'
    )
    const itemExport = record?.assetHistories?.filter(
      item => item?.type === 'EXPORT'
    )

    const totalLastMonth = itemLastMonth.reduce(
      (total, item) => total + item.quantity,
      0
    )
    const totalCreate = itemCreate.reduce(
      (total, item) => total + item.quantity,
      0
    )
    const totalUpdate = itemUpdate.reduce(
      (total, item) => total + item.quantity,
      0
    )
    const totalExport = itemExport.reduce(
      (total, item) => total + item.quantity,
      0
    )
    let finalTotal = 0
    let totalMoney = 0
    let totalMoneyTax = 0
    const [compareMonth, compareYear] = currentDate.split('-')
    const currentDateObject = new Date(compareYear, compareMonth - 1)

    const now = new Date()
    const currentMonthYearObject = new Date(now.getFullYear(), now.getMonth())

    const itemUpdateLast = record?.assetHistories
      ?.filter(item => item?.type !== 'LASTMONTH')
      .reduce((latestItem, currentItem) => {
        if (
          !latestItem ||
          new Date(currentItem.createAt) > new Date(latestItem.createAt)
        ) {
          return currentItem
        }
        return latestItem
      }, null)

    if (currentDateObject < currentMonthYearObject) {
      finalTotal = totalLastMonth + totalCreate + totalUpdate - totalExport
      totalMoney = Number(finalTotal) * Number(itemUpdateLast?.price)
      totalMoneyTax = Number(finalTotal) * Number(itemUpdateLast?.totalMoney)
    }
    return {
      finalTotal,
      totalMoney,
      totalMoneyTax,
      itemUpdateLast,
    }
  }

  const tableColumns = [
    {
      title: 'STT',
      width: 30,
      render: (id, record, index) => (
        <span title={pageIndex * sizeIndex + index + 1}>
          {pageIndex * sizeIndex + index + 1}
        </span>
      ),
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Tên dụng cụ, văn phòng phẩm',
      width: 150,
      render: record => {
        return <span>{record?.asset?.assetName}</span>
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Đơn vị tính',
      width: 50,
      render: record => {
        return <span>{record?.asset?.assetUnitName}</span>
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Thuế',
      width: 50,
      render: record => {
        return (
          <span>
            {calculateAssetStatistics(record).itemUpdateLast?.tax
              ? `${calculateAssetStatistics(record).itemUpdateLast.tax}%`
              : '----'}
          </span>
        )
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Đơn giá trước thuế',
      width: 100,
      render: record => {
        return (
          <span>
            {calculateAssetStatistics(record).itemUpdateLast
              ? parseFloat(
                  calculateAssetStatistics(record).itemUpdateLast.price
                ).toLocaleString('vi-VN')
              : '----'}
          </span>
        )
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Đơn giá sau thuế',
      width: 100,
      render: record => {
        return (
          <span>
            {calculateAssetStatistics(record).itemUpdateLast
              ? parseFloat(
                  calculateAssetStatistics(record).itemUpdateLast.totalMoney
                ).toLocaleString('vi-VN')
              : '----'}
          </span>
        )
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Tồn đầu kỳ (Số lượng)',
      width: 100,
      render: record => {
        const openingBalanceItem = record?.assetHistories?.reduce(
          (selectedItem, item) => {
            const itemDate = new Date(item?.createAt)
            const [compareMonth, compareYear] = currentDate.split('-')
            const currentDateObject = new Date(compareYear, compareMonth - 1)
            if (
              item?.type === 'LASTMONTH' &&
              (itemDate.getFullYear() < currentDateObject.getFullYear() ||
                (itemDate.getFullYear() === currentDateObject.getFullYear() &&
                  itemDate.getMonth() < currentDateObject.getMonth()))
            ) {
              if (
                !selectedItem ||
                new Date(item.createAt) < new Date(selectedItem.createAt)
              ) {
                return item
              }
            }
            return selectedItem
          },
          null
        )

        const openingBalanceQuantity = openingBalanceItem
          ? openingBalanceItem.quantity
          : 0

        return <span>{openingBalanceQuantity}</span>
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Nhập trong kỳ (Số lượng)',
      width: 100,
      render: record => {
        const periodImportQuantity = record?.assetHistories?.reduce(
          (quantity, item) => {
            if (item?.type === 'CREATE' || item?.type === 'UPDATE') {
              quantity += item.quantity
            }
            return quantity
          },
          0
        )
        return <span>{periodImportQuantity}</span>
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Xuất trong kỳ (Số lượng)',
      width: 100,
      render: record => {
        const periodExportQuantity = record?.assetHistories?.reduce(
          (quantity, item) => {
            if (item?.type === 'EXPORT') {
              quantity += item.quantity
            }
            return quantity
          },
          0
        )
        return <span>{periodExportQuantity}</span>
      },
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Tồn cuối kỳ',
      children: [
        {
          title: 'Số lượng',
          width: 100,
          render: record => {
            const finalTotal = calculateAssetStatistics(record).finalTotal
            return <span>{finalTotal}</span>
          },
          align: 'center',
          ellipsis: true,
        },
        {
          title: 'Thành tiền trước thuế',
          width: 100,
          render: record => {
            const totalMoney = calculateAssetStatistics(record).totalMoney
            return <span>{totalMoney.toLocaleString('vi-VN')}</span>
          },
          align: 'center',
          ellipsis: true,
        },
        {
          title: 'Thành tiền sau thuế',
          width: 100,
          render: record => {
            const totalMoneyTax = calculateAssetStatistics(record).totalMoneyTax
            return <span>{totalMoneyTax.toLocaleString('vi-VN')}</span>
          },
          align: 'center',
          ellipsis: true,
        },
      ],
    },
  ]

  return (
    <>
      <TableComponent
        scroll={{
          x: 2000,
        }}
        bordered
        // @ts-ignore
        dataSource={assetStatisticList?.data}
        // @ts-ignore
        columns={tableColumns}
        pagination={false}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Không có dữ liệu'}
            />
          ),
        }}
        loading={isLoading}
      />

      <TableBottomPaginationBlock>
        <Pagination
          current={pageIndex + 1}
          pageSize={sizeIndex}
          total={totalCount}
          showSizeChanger={false}
          onChange={handleChangePage}
        />
      </TableBottomPaginationBlock>
    </>
  )
}

export default inject('managementAssetWarehouseStore')(
  observer(AssetStatisticsTable)
)
